import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { RouterModule } from "@angular/router";
import { BrowserModule } from "@angular/platform-browser";

import { AppComponent } from "./app.component";
import { AdminLayoutComponent } from "./layouts/admin-layout/admin-layout.component";
import { AuthLayoutComponent } from "./layouts/auth-layout/auth-layout.component";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

import { ToastrModule } from "ngx-toastr";
import { AppRoutingModule } from "./app.routing";
import { ComponentsModule } from "./components/components.module";
import { ErrorInterceptor } from "./utils/error.interceptor";
import { JwtInterceptor } from "./utils/jwt.interceptor";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { SweetAlert2Module } from "@sweetalert2/ngx-sweetalert2";
import { MDBBootstrapModule } from "ng-uikit-pro-standard";
import { MDBBootstrapModulesPro } from "ng-uikit-pro-standard";
import { NgWizardModule, NgWizardConfig, THEME } from "ng-wizard";
import { MatGoogleMapsAutocompleteModule } from "@angular-material-extensions/google-maps-autocomplete";
import { AgmCoreModule } from "@agm/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatDatepickerModule } from "@angular/material/datepicker";

import { MatNativeDateModule } from "@angular/material/core";

const ngWizardConfig: NgWizardConfig = {
  theme: THEME.circles,
};
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";

// import { CanActivateViaAuthGuard } from "./auth.guard";
// providers: [CanActivateViaAuthGuard],

@NgModule({
  imports: [
    BrowserModule,
    MatDatepickerModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    FormsModule,
    MDBBootstrapModule.forRoot(),
    MDBBootstrapModulesPro.forRoot(),
    SweetAlert2Module.forRoot(),
    HttpClientModule,
    ComponentsModule,
    NgbModule,
    RouterModule,
    AppRoutingModule,
    NgWizardModule.forRoot(ngWizardConfig),
    MatGoogleMapsAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyAa33KXwzbvxFFvxu0qDRRPwcj8nWXrWP0",
      libraries: ["places"],
    }),
  ],
  exports: [
    MatDatepickerModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    MatNativeDateModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [AppComponent, AdminLayoutComponent, AuthLayoutComponent],
  providers: [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: "fill" },
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
